const aplicacoes = [
  'Open office',
  'Salas de reunião',
  'Diretorias',
  'Corredores',
  'Recepções',
  'Auditórios',
  'Coworkings',
  'Hotéis',
  'Salas de treinamento',
  'Ambientes de tecnologia',
];

const icones: Record<string, string> = {
  'Open office': 'ri-layout-grid-line',
  'Salas de reunião': 'ri-team-line',
  Diretorias: 'ri-vip-crown-line',
  Corredores: 'ri-route-line',
  'Recepções': 'ri-customer-service-2-line',
  'Auditórios': 'ri-presentation-line',
  'Coworkings': 'ri-community-line',
  'Hotéis': 'ri-hotel-bed-line',
  'Salas de treinamento': 'ri-graduation-cap-line',
  'Ambientes de tecnologia': 'ri-cpu-line',
};

export default function AplicacoesSection() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Aplicações
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Ambientes onde o carpete corporativo se destaca.
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {aplicacoes.map((a) => (
            <div
              key={a}
              className="bg-background-50 border border-background-200/60 rounded-2xl p-5 text-center hover:border-primary-300 transition-colors"
            >
              <span className="w-10 h-10 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3">
                <i className={`${icones[a] ?? 'ri-building-line'} text-xl`}></i>
              </span>
              <p className="text-foreground-800 text-[14px] font-medium leading-snug">{a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}